import { render, staticRenderFns } from "./funes_pres_detalle_XM.vue?vue&type=template&id=4aebba48"
import script from "./funes_pres_detalle_XM.vue?vue&type=script&lang=js"
export * from "./funes_pres_detalle_XM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports